module.exports = "/assets/9ed60b0fb3d4cb9aead71b450a9ab3eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/AA.png
// module id = 1188
// module chunks = 0